<ng-template matMenuContent>
    <div class="cm-copy-value-to-clipboard-menu-container">
        @for (copyItem of $copyItems(); track copyItem.displayText) {
            <button mat-menu-item (click)="copyValueToClipboard($event, copyItem)">
                @if (copyItem.icon) {
                    <i class="{{ copyItem.icon }}"></i>
                }
                {{ copyItem.displayText }}
            </button>
        }
    </div>
</ng-template>
